const STORAGE_KEY = "he_house_invite_token";

export function storeHouseInviteTokenFromSearchParams(
  params: URLSearchParams,
): string | null {
  const raw = params.get("invite");
  if (typeof raw === "string" && raw.trim().length >= 32) {
    const t = raw.trim();
    sessionStorage.setItem(STORAGE_KEY, t);
    return t;
  }
  return getStoredHouseInviteToken();
}

export function getStoredHouseInviteToken(): string | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearStoredHouseInviteToken(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEY);
}
